import { connect } from 'react-redux';
import { withTranslation } from '@piwikpro/ui-components';
import AddUsers from './AddUsers';

const mapStateToProps = state => ({
  userGroup: state.userGroups.details.userGroup,
  nonMembers: state.userGroups.nonMembers.list,
  total: state.userGroups.nonMembers.total,
  isLoading: state.userGroups.nonMembers.isLoading,
  failed: state.userGroups.nonMembers.failed,
});

export default connect(mapStateToProps)(withTranslation(['administration', 'components'])(AddUsers));
